import { Directive, TemplateRef } from '@angular/core';

@Directive({selector: '[appQuerySwitchGroup]'})
export class QuerySwitchGroupDirective {
  constructor(public template: TemplateRef<any>) {}
}
